import { startAuthentication, startRegistration } from "@simplewebauthn/browser";
import { api } from "./api";

export const passkeysSupported = () =>
  typeof window !== "undefined" && !!window.PublicKeyCredential && !!navigator.credentials;

export interface PasskeyRow {
  id: string;
  name: string;
  device_type: string | null;
  backed_up: number;
  created_at: number;
  last_used_at: number | null;
}

/** Registers a passkey for the signed-in user (the browser shows the fingerprint / face / PIN prompt). */
export async function addPasskey(name: string) {
  const options = await api<Parameters<typeof startRegistration>[0]["optionsJSON"]>(
    "/auth/passkeys/register/options",
    { method: "POST", body: {} },
  );
  const response = await startRegistration({ optionsJSON: options });
  await api("/auth/passkeys/register/verify", { method: "POST", body: { response, name } });
}

/** Signs in with a discoverable passkey — no email or password needed. */
export async function signInWithPasskey() {
  const { options, ticket } = await api<{
    options: Parameters<typeof startAuthentication>[0]["optionsJSON"];
    ticket: string;
  }>("/auth/passkeys/login/options", { method: "POST", body: {} });
  const response = await startAuthentication({ optionsJSON: options });
  return api("/auth/passkeys/login/verify", { method: "POST", body: { ticket, response } });
}

export const deviceName = () => {
  const ua = navigator.userAgent;
  const os = /Android/i.test(ua)
    ? "Android"
    : /iPhone|iPad/i.test(ua)
      ? "iOS"
      : /Windows/i.test(ua)
        ? "Windows"
        : /Mac/i.test(ua)
          ? "Mac"
          : /Linux/i.test(ua)
            ? "Linux"
            : "Device";
  return `${os} · ${new Date().toISOString().slice(0, 10)}`;
};
